import { saveAs } from 'file-saver';


//shopby pro SA 코드임. pro 디렉토리 master에 merge 되면 거기 코드 사용하기
export const saveBlobToFile = (blob: Blob, fileName: string) => {
  saveAs(blob, fileName.normalize('NFC'));
};

export const saveBinaryDataToFile = (arrayBuffer: ArrayBuffer, fileName: string): void => {
  const blob = new Blob([arrayBuffer], { type: 'application/octet-stream' });
  saveBlobToFile(blob, fileName);
};
